// src/pages/Blog.js
import React, { useEffect, useState } from 'react';
import './Blog.css';
import { Link } from 'react-router-dom';

const blogTypeLabels = {
  0: 'None',
  1: 'Essay',
  2: 'News',
  4: 'Report',
};

const Blog = () => {
  const [entries, setEntries] = useState([]);
  const [selectedType, setSelectedType] = useState('');
  const [selectedMonth, setSelectedMonth] = useState('');
  const [selectedYear, setSelectedYear] = useState('');

  useEffect(() => {
    fetch('https://affeerce-backend.onrender.com/api/blogEntries')
      .then(res => res.json())
      .then(data => {
        setEntries(data);

        const now = new Date();
        setSelectedMonth((now.getMonth() + 1).toString());
        setSelectedYear(now.getFullYear().toString());
      })
      .catch(err => console.error('Error fetching blog entries:', err));
  }, []);

  const filterByDate = (entry) => {
    const date = new Date(entry.CreatedAt);
    const yearMatch = selectedYear ? date.getFullYear().toString() === selectedYear : true;
    const monthMatch = selectedMonth ? (date.getMonth() + 1).toString() === selectedMonth : true;
    return yearMatch && monthMatch;
  };

  const filteredEntries = entries
    .filter(entry => (selectedType ? blogTypeLabels[entry.BlogType] === selectedType : true))
    .filter(filterByDate);

  const uniqueTypes = Array.from(new Set(entries.map(e => blogTypeLabels[e.BlogType])));
  const uniqueYears = Array.from(new Set(entries.map(e => new Date(e.CreatedAt).getFullYear().toString())));
  const months = [...Array(12).keys()].map(i => ({ num: (i + 1).toString(), name: new Date(0, i).toLocaleString('default', { month: 'long' }) }));

  return (
    <div className="blog-container">
      <h2>AFFEERCE Blog</h2>
      <p>
        Explore essays and news. To comment, please log in to the Toolkit and go to Henry George Library → Essays and News.
      </p>

      <div className="filters">
        <select value={selectedType} onChange={e => setSelectedType(e.target.value)}>
          <option value="">All Types</option>
          {uniqueTypes.map((type, idx) => <option key={idx} value={type}>{type}</option>)}
        </select>

        <select value={selectedMonth} onChange={e => setSelectedMonth(e.target.value)}>
          <option value="">All Months</option>
          {months.map(m => <option key={m.num} value={m.num}>{m.name}</option>)}
        </select>

        <select value={selectedYear} onChange={e => setSelectedYear(e.target.value)}>
          <option value="">All Years</option>
          {uniqueYears.map((year, idx) => <option key={idx} value={year}>{year}</option>)}
        </select>
      </div>

      <div className="blog-entries">
  {filteredEntries.map((entry, index) => (
    <div
      className="blog-entry-card"
      key={entry.Id}
      style={{ animationDelay: `${index * 0.1}s` }}
    >
      <h3>{entry.AuthorName}</h3>
      <h4>{entry.Title}</h4>
      <p><strong>Type:</strong> {blogTypeLabels[entry.BlogType]}</p>
      <p><strong>Date:</strong> {new Date(entry.CreatedAt).toLocaleDateString()}</p>
      <Link to={`/blog/${entry.Id}`} state={{ entry }}>
        Read More
      </Link>
    </div>
  ))}
</div>
    </div>
  );
};

export default Blog;
